// ControllerHint
// Features:
// - Displays movement controls (WASD, Crouch, Exit)
// - Visible only in cabin when UI and hints are enabled

import { usePhase, PHASES } from '../../../store/usePhase'
import { useStore } from '../../../store/useStore'
import './hint.css'

export default function ControllerHint() {
    const phase = usePhase((state) => state.phase)
    const hintsHidden = useStore((state) => state.hintsHidden)
    const uiOn = useStore((state) => state.uiOn)

    const isVisible = uiOn && phase === PHASES.inCabin && !hintsHidden

    if (!isVisible) return null

    return (
        <div className="ctrl-hint">
            <div className="ctrl-hint__box">
                <div className="ctrl-hint__line">WASD — Move</div>
                <div className="ctrl-hint__line">C — Crouch</div>
                <div className="ctrl-hint__line">
                    ESC - Exit Pointer Lock Mode
                </div>
            </div>
        </div>
    )
}
